import { Component, inject } from '@angular/core';
import { table, CacTableComponent } from '@controladad/ng-base';
import { cacTableIdCol, ReviewApiService, ReviewStatusValues } from '@core';

@Component({
  selector: 'lib-reviews-list',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './reviews-list.component.html',
  styleUrl: './reviews-list.component.scss',
})
export class ReviewsListComponent {
  private readonly reviewApi = inject(ReviewApiService);
  readonly RATING_ITEMS = [
    { label: '1 Star', value: 1 },
    { label: '2 Stars', value: 2 },
    { label: '3 Stars', value: 3 },
    { label: '4 Stars', value: 4 },
    { label: '5 Stars', value: 5 },
  ];
  table = table({
    itemsFn: this.reviewApi.getAdapter(),
    view: {
      itemName: 'Admin User',
    },
    columns: {
      id: cacTableIdCol(),
      fullName: { label: 'Full Name', sortable: true, filterable: true },
      email: { label: 'Email', sortable: true, filterable: true },
      rating: { label: 'Rating', sortable: true, filterable: true, items: this.RATING_ITEMS },
      review: { label: 'Review', sortable: true, filterable: true },
      'productName.english': {
        label: 'English Product Name',
        sortable: 'ProductEnglishName',
        filterable: 'EnglishProductName',
      },
      'productName.arabic': {
        label: 'Arabic Product Name',
        sortable: 'ProductArabicName',
        filterable: 'ArabicProductName',
      },
      createdAt: {
        label: 'Created At',
        sortable: true,
        filterable: [
          { type: 'greater', label: 'From', controlType: 'datetime', key: 'CreatedAtFrom' },
          { type: 'lower', controlType: 'datetime', key: 'CreatedAtTo' },
        ],
        type: 'datetime',
      },
      status: { label: 'Status', sortable: true, filterable: true, type: 'tag', items: ReviewStatusValues },
    },
    bulkActions: [
      {
        content: 'Approve',
        action: (items) => this.reviewApi.changeReviewStatus(mapIds(items), 1),
      },
      {
        content: 'Un-Approve',
        action: (items) => this.reviewApi.changeReviewStatus(mapIds(items), 0),
      },
      {
        content: 'Delete',
        action: (items) => dialog$.deletePrompt(true, { itemName: 'Reviews' }).action(() => this.reviewApi.delete(mapIds(items))),
      },
    ],
  });
}

const mapIds = (items: { id: number }[]) => items.map((i) => i.id);
